<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  <div class="monitor_container-column">
    @if (osState) {
      <div class="monitor_graph-box monitor_graph-box--single" >
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
        <div class="monitor_list-container">
          <div class="monitor_stat-title">
            @if (currentOsSection) {
              <span>{{'currentlyTesting' | translate | uppercase}}</span>
            }
            @if (osState.result) {
              <span>{{'testScore' | translate | uppercase}}</span>
            }
          </div>
          @if (currentOsSection) {
            <div class="monitor_text-box">
              <strong>{{sectionNames[currentOsSection.section] | titlecase}} {{'section' | translate | titlecase}}</strong>
              <div>{{ 'correctAnswers' | translate }}: {{currentOsSection.correct_answers}} &#47; {{currentOsSection.total_answers}}</div>
            </div>
          }
          @if (osState.result) {
            <div class="monitor_text-box">
              {{ getEyeResultText(osState.result) }}
            </div>
          }
        </div>
      </div>
    }

    @if (odState) {
      <div class="monitor_graph-box monitor_graph-box--single" >
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
        <div class="monitor_list-container">
          <div class="monitor_stat-title">
            @if (currentOdSection) {
              <span>{{'currentlyTesting' | translate | uppercase}}</span>
            }
            @if (odState.result) {
              <span>{{'testScore' | translate | uppercase}}</span>
            }
          </div>
          @if (currentOdSection) {
            <div class="monitor_text-box">
              <strong>{{sectionNames[currentOdSection.section] | titlecase}} {{'section' | translate | titlecase}}</strong>
              <div>{{ 'correctAnswers' | translate }}: {{currentOdSection.correct_answers}} &#47; {{currentOdSection.total_answers}}</div>
            </div>
          }
          @if (odState.result) {
            <div class="monitor_text-box">
              {{ getEyeResultText(odState.result) }}
            </div>
          }
        </div>
      </div>
    }

    @if (bothState) {
      <div class="monitor_graph-box monitor_graph-box--single" >
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_list-container">
          <div class="monitor_stat-title">
            @if (currentBothSection) {
              <span>{{'currentlyTesting' | translate | uppercase}}</span>
            }
            @if (bothState.result) {
              <span>{{'testScore' | translate | uppercase}}</span>
            }
          </div>
          @if (currentBothSection) {
            <div class="monitor_text-box">
              <strong>{{sectionNames[currentBothSection.section] | titlecase}} {{'section' | translate | titlecase}}</strong>
              <div>{{ 'correctAnswers' | translate }}: {{currentBothSection.correct_answers}} &#47; {{currentBothSection.total_answers}}</div>
            </div>
          }
          @if (bothState.result) {
            <div class="monitor_text-box">
              {{ getEyeResultText(bothState.result) }}
            </div>
          }
        </div>
      </div>
    }
  </div>

  <div class="monitor_container-column">
    @if (osState) {
      <div class="monitor_graph-box monitor_graph-box--single">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
        <app-percentage-circle
          id="test-percentage-left"
          class="monitor_circle-box"
          [percentage]="osState.percentage_done">
        </app-percentage-circle>
      </div>
    }
    @if (odState) {
      <div class="monitor_graph-box monitor_graph-box--single">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
        <app-percentage-circle
          id="test-percentage-right"
          class="monitor_circle-box"
          [percentage]="odState.percentage_done">
        </app-percentage-circle>
      </div>
    }
    @if (bothState) {
      <div class="monitor_graph-box monitor_graph-box--single">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <app-percentage-circle
          id="test-percentage-both"
          class="monitor_circle-box"
          [percentage]="bothState.percentage_done">
        </app-percentage-circle>
      </div>
    }
  </div>

  <div class="monitor_container-column">
    @if (osState?.sections) {
      <div class="monitor_graph-box monitor_graph-box--single" >
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
        <div class="monitor_list-container">
          <div class="monitor_stat-title">
            {{'completedSections' | translate | uppercase}}
          </div>
          <br>
            @for (section of osState.sections; track section.id) {
              <div
                [hidden]="!section.done"
                class="monitor_list-item monitor_list-item--simple">
                <div [ngClass]="{'text--blink': !section.all_data_received}">
                  {{sectionNames[section.section] | titlecase}}
                  @if (!section.all_data_received) {
                    <span class="hidden-mobile--sm">&#40;{{'syncing' | translate | titlecase}}&#41;</span>
                  }
                </div>
                <div class="{{getSectionClass(section)}}" [ngClass]="{'text--blink': !section.all_data_received}">
                  <span class="hidden-mobile--sm">{{section.result?.toLowerCase() | translate | titlecase}}&nbsp;</span>
                  <span class="hidden-mobile--sm">&#40;</span>{{section.correct_answers}}&#47;{{section.total_answers}}<span class="hidden-mobile--sm">&#41;</span>
                </div>
              </div>
            }
          </div>
        </div>
      }

      @if (odState?.sections) {
        <div class="monitor_graph-box monitor_graph-box--single" >
          @if (isTestSyncing) {
            <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
          }
          <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
          <div class="monitor_list-container">
            <div class="monitor_stat-title">
              {{'completedSections' | translate | uppercase}}
            </div>
            <br>
              @for (section of odState.sections; track section.id) {
                <div
                  [hidden]="!section.done"
                  class="monitor_list-item monitor_list-item--simple">
                  <div [ngClass]="{'text--blink': !section.all_data_received}">
                    {{sectionNames[section.section] | titlecase}}
                    @if (!section.all_data_received) {
                      <span class="hidden-mobile--sm">&#40;{{'syncing' | translate | titlecase}}&#41;</span>
                    }
                  </div>
                  <div class="{{getSectionClass(section)}}" [ngClass]="{'text--blink': !section.all_data_received}">
                    <span class="hidden-mobile--sm">{{section.result?.toLowerCase() | translate | titlecase}}&nbsp;</span>
                    <span class="hidden-mobile--sm">&#40;</span>{{section.correct_answers}}&#47;{{section.total_answers}}<span class="hidden-mobile--sm">&#41;</span>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        @if (bothState?.sections) {
          <div class="monitor_graph-box monitor_graph-box--single" >
            @if (isTestSyncing) {
              <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
            }
            <div class="monitor_list-container">
              <div class="monitor_stat-title">
                {{'completedSections' | translate | uppercase}}
              </div>
              <br>
                @for (section of bothState.sections; track section.id) {
                  <div
                    [hidden]="!section.done"
                    class="monitor_list-item monitor_list-item--simple">
                    <div [ngClass]="{'text--blink': !section.all_data_received}">
                      {{sectionNames[section.section] | titlecase}}
                      @if (!section.all_data_received) {
                        <span class="hidden-mobile--sm">&#40;{{'syncing' | translate | titlecase}}&#41;</span>
                      }
                    </div>
                    <div class="{{getSectionClass(section)}}" [ngClass]="{'text--blink': !section.all_data_received}">
                      <span class="hidden-mobile--sm">{{section.result?.toLowerCase() | translate | titlecase}}&nbsp;</span>
                      <span class="hidden-mobile--sm">&#40;</span>{{section.correct_answers}}&#47;{{section.total_answers}}<span class="hidden-mobile--sm">&#41;</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </app-monitor-layout>